// import React, { lazy, Suspense, useState, useEffect } from 'react';
// import { useLocation, useNavigate } from 'react-router-dom'; // Import useLocation and useNavigate
// import Breadcrumbs from './Breadcrumbs';
// import SideBar from './SideBar';
// import CompanyProfile from './Content/CompanyActions/CompanyProfile';
// import AllJob from './Content/CompanyActions/ViewJobs';
// import Dashboard from './Content/Dashboard';
// import ScheduleTestt from './Content/CompanyActions/JobActions/ScheduleTest';

// const AllCompanies = lazy(() => import('./Content/AllCompanies'));
// const AddCompany = lazy(() => import('./Content/AddCompany'));

// const DeleteCompanyPopup = lazy(() => import('./Content/CompanyActions/DeleteCompanyPopup'));
// const CreateJDForm = lazy(() => import('./Content/CompanyActions/MainContent'));
// const UploadJDForm = lazy(() => import('./Content/CompanyActions/UploadJD'));
// // const GenerateJDAIForm = lazy(() => import('./Content/JobActions/GenerateJDAIForm')); // Assuming this path
// const AfterJD = lazy(() => import('./Content/CompanyActions/AfterJD')); // Assuming this path
// const EditCompanyProfile = lazy(() => import('./Content/CompanyActions/EditCompanyProfile'));

// const JobDescription = lazy(() => import('./Content/CompanyActions/JobActions/JobDescription'));
// const EnrollCandidatePopup = lazy(() => import('./Content/CompanyActions/JobActions/UploadResume'));
// const ViewAllCandidates = lazy(() => import('./Content/CompanyActions/JobActions/All'));
// const DeleteJobPopup = lazy(() => import('./Content/CompanyActions/JobActions/DeleteJobPopup'));
// const EditJob = lazy(() => import('./Content/CompanyActions/JobActions/MainContent')); // Assuming this path

// // Function to get activeMain from path (handles dynamic segments)
// const getActiveMainFromPath = (pathname) => {
//     if (pathname.startsWith('/company-admin-home')) return 'dashboard';
//     if (pathname.startsWith('/all-companies')) return 'all-companies';
//     if (pathname.startsWith('/add-company-profile')) return 'add-company';
//     if (pathname.startsWith('/company-profile')) return 'company-profile';
//     if (pathname.startsWith('/all-jobs')) return 'view-jobs';
//     if (pathname.startsWith('/create-JD')) return 'create-jd';
//     if (pathname.startsWith('/upload-JD')) return 'upload-jd';
//     if (pathname.startsWith('/after-JD')) return 'after-jd';
//     if (pathname.startsWith('/edit-company-profile')) return 'edit-company-profile'; // Re-use company profile for edit
//     if (pathname.startsWith('/job-description')) return 'job-description';
//     if (pathname.startsWith('/all-candidates')) return 'view-all-candidates';
//     if (pathname.startsWith('/edit-job')) return 'edit-job';
//     if (pathname.startsWith('/view-test')) return 'view-test';

//      // Assuming this is a valid path

//     return 'dashboard'; // Or 'all-companies' based on your default view
// };


// export default function Content() {
//     const location = useLocation(); // Get current URL location
//     const navigate = useNavigate(); // Get navigate function
//     const jobID = new URLSearchParams(location.search).get("jobID");
//     const companyID = new URLSearchParams(location.search).get("companyID");
//     const [activeMain, setActiveMain] = useState(() => getActiveMainFromPath(location.pathname));
//     const [selectedJob, setSelectedJob] = useState(null);
//     const [selectedCompany, setSelectedCompany] = useState(null);
//     const [showDeleteCompanyPopup, setShowDeleteCompanyPopup] = useState(false);
//     const [showDeleteJobPopup, setShowDeleteJobPopup] = useState(false);
//     const [showEnrollCandidatePopup, setShowEnrollCandidatePopup] = useState(false);
//     const [previousActiveMain, setPreviousActiveMain] = useState('dashboard');

//     // useEffect(() => {
//     //     const fetchJobDescription = async (jobId) => {
//     //         try {
//     //             const response = await fetch(`/api/job_description?jobId=${jobId}`);
//     //             if (response.ok) {
//     //                 const jobData = await response.json();
//     //                 console.log("Job Description:", jobData);
//     //                 setJobName(jobData.job_title);
//     //             }
//     //         } catch (error) {
//     //             console.error("Error fetching job description:", error);
//     //         }
//     //     };

//     //     fetchJobDescription(jobID);
//     // }, [jobID]);

//     // const fetchCompanyByID = async (companyID) => {
//     //     try {
//     //         console.log("companyID", companyID);
//     //         const response = await fetch(`/api/get_company_by_ID?companyID=${encodeURIComponent(companyID)}`, {
//     //             method: "GET",
//     //             // headers: { "Content-Type": "application/json" },
//     //         });
//     //         if (!response.ok) {
//     //             throw new Error("Failed to fetch company");
//     //         }
//     //         const data = await response.json();
//     //         console.log("Company Data:", data);
//     //         setCompanyName(data.company_name); // Set the company data to state
//     //         // setCompanyEmail(data.email); // Set the company email from the fetched data
//     //         return data;
//     //     } catch (error) {
//     //         console.error("Error fetching company:", error);
//     //         return null;
//     //     }
//     // };

//     // useEffect(() => {
//     //     const fetchData = async () => {
//     //         await fetchCompanyByID(companyID);
//     //     };
//     //     if (companyID) fetchData();
//     // }, [companyID]);

//     // Update activeMain when URL changes
//     useEffect(() => {
//         const newActiveMain = getActiveMainFromPath(location.pathname);
//         if (newActiveMain !== activeMain) {
//             setActiveMain(newActiveMain);
//         }
//     }, [location.pathname]); // Re-run when pathname changes

//     // Update previousActiveMain for popup context
//     useEffect(() => {
//         if (!showDeleteCompanyPopup && !showDeleteJobPopup && !showEnrollCandidatePopup && activeMain !== previousActiveMain) {
//             setPreviousActiveMain(activeMain);
//         }
//     }, [activeMain, showDeleteCompanyPopup, showDeleteJobPopup, showEnrollCandidatePopup, previousActiveMain]);


//     const handleDeleteCompanyClick = () => {
//         setPreviousActiveMain(activeMain); // Store current activeMain
//         setShowDeleteCompanyPopup(true);
//     };

//     const handleCloseDeleteCompanyPopup = () => {
//         setShowDeleteCompanyPopup(false);
//         // Optionally, navigate back to previousActiveMain if needed, but usually not for modals
//     };

//     const handleConfirmDeleteCompany = () => {
//         console.log("Company deleted!");
//         setShowDeleteCompanyPopup(false);
//         setSelectedCompany(null);
//         navigate('/all-companies'); // Navigate to all companies after deletion
//     };

//     const handleDeleteJobClick = () => {
//         setPreviousActiveMain(activeMain);
//         setShowDeleteJobPopup(true);
//     };

//     const handleCloseDeleteJobPopup = () => {
//         setShowDeleteJobPopup(false);
//     };

//     const handleConfirmDeleteJob = (companyID) => {
//         console.log("Job deleted!");
//         setShowDeleteJobPopup(false);
//         setSelectedJob(null);
//         navigate(`/all-jobs?companyID=${encodeURIComponent(companyID)}`, {
//             state: { companyID: companyID } // Pass companyID in state if needed
//         }); // Navigate back to view jobs
//     };

//     const handleEnrollCandidateClick = () => {
//         setPreviousActiveMain(activeMain);
//         setShowEnrollCandidatePopup(true);
//     };

//     const handleCloseEnrollCandidatePopup = () => {
//         setShowEnrollCandidatePopup(false);
//     };

//     const handleConfirmEnrollCandidate = () => {
//         console.log("Candidate Resume Uploaded!");
//         setShowEnrollCandidatePopup(false);
//         // No navigation needed, stays on current page
//     };

//     return (
//         <div className="page-container">
//             <div className="content-container">
//                 <SideBar
//                     activeMain={activeMain}
//                     setActiveMain={setActiveMain} // Still pass setActiveMain for internal logic if needed
//                     selectedCompany={selectedCompany}
//                     selectedJob={selectedJob}
//                     setSelectedCompany={setSelectedCompany}
//                     setSelectedJob={setSelectedJob}
//                     onDeleteCompanyClick={handleDeleteCompanyClick}
//                     onDeleteJobClick={handleDeleteJobClick}
//                     onEnrollCandidateClick={handleEnrollCandidateClick}
//                     navigate={navigate} // Pass navigate to SideBar
//                 />
//                 <div style={{ width: "100%" }}>
//                     <Breadcrumbs
//                         // companyName={companyName} // Pass companyName to Breadcrumbs
//                         // jobName={jobName} // Pass jobName to Breadcrumbs
//                         activeMain={activeMain}
//                         selectedCompany={selectedCompany}
//                         selectedJob={selectedJob}
//                         setSelectedCompany={setSelectedCompany}
//                         setSelectedJob={setSelectedJob}
//                         navigate={navigate} // Pass navigate to Breadcrumbs if it needs to link
//                     />
//                     <div>
//                         <Suspense fallback={<div>Loading...</div>}>
//                             {/* Render components based on activeMain */}
//                             {activeMain === 'dashboard' && <Dashboard/>}
//                             {activeMain === 'all-companies' && <AllCompanies setActiveMain={setActiveMain} setSelectedCompany={setSelectedCompany} />}
//                             {activeMain === 'add-company' && <AddCompany />}

//                             {activeMain === 'company-profile' && <CompanyProfile activeMain={activeMain} setActiveMain={setActiveMain} selectedCompany={selectedCompany} setSelectedCompany={setSelectedCompany} />}
//                             {activeMain === 'view-jobs' && <AllJob selectedCompany={selectedCompany} setActiveMain={setActiveMain} setSelectedJob={setSelectedJob} />}
//                             {activeMain === 'create-jd' && <CreateJDForm selectedCompany={selectedCompany} />}
//                             {activeMain === 'upload-jd' && <UploadJDForm selectedCompany={selectedCompany} />}
//                             {activeMain === 'after-jd' && <AfterJD />}
//                             {activeMain === 'edit-company-profile' && <EditCompanyProfile activeMain={activeMain} setActiveMain={setActiveMain} selectedCompany={selectedCompany} setSelectedCompany={setSelectedCompany} />}

//                             {activeMain === 'job-description' && <JobDescription selectedCompany={selectedCompany} selectedJob={selectedJob} />}
//                             {activeMain === 'view-all-candidates' && <ViewAllCandidates selectedJob={selectedJob} handleEnrollCandidateClick={handleEnrollCandidateClick} />}
//                             {activeMain === 'edit-job' && <EditJob activeMain={activeMain} setActiveMain={setActiveMain} selectedCompany={selectedCompany} setSelectedCompany={setSelectedCompany} />}
//                             {/* Add other components for edit-job, view-scheduled-tests etc. */}
//                             {activeMain === 'view-test' && <ScheduleTestt candidates={selectedJob?.candidates || []} jobDetails={selectedJob} selectedJobId={selectedJob?.job_id} onClose={() => setActiveMain(previousActiveMain)} />}

//                         </Suspense>
//                     </div>
//                 </div>
//             </div>

//             {showDeleteCompanyPopup && (
//                 <Suspense fallback={<div>Loading Delete Popup...</div>}>
//                     <DeleteCompanyPopup
//                         companyName={selectedCompany?.name || 'the selected company'}
//                         onClose={handleCloseDeleteCompanyPopup}
//                         onConfirm={handleConfirmDeleteCompany}
//                     />
//                 </Suspense>
//             )}

//             {showDeleteJobPopup && (
//                 <Suspense fallback={<div>Loading Delete Popup...</div>}>
//                     <DeleteJobPopup
//                         jobName={selectedJob?.job_title || 'the selected job'}
//                         onClose={handleCloseDeleteJobPopup}
//                         onConfirm={handleConfirmDeleteJob}
//                     />
//                 </Suspense>
//             )}

//             {showEnrollCandidatePopup && (
//                 <Suspense fallback={<div>Loading Enroll Popup...</div>}>
//                     <EnrollCandidatePopup
//                         jobId={selectedJob?.job_id || 'the selected job'}
//                         onClose={handleCloseEnrollCandidatePopup}
//                         onConfirm={handleConfirmEnrollCandidate}
//                     />
//                 </Suspense>
//             )}
//         </div>
//     );
// }



// import React, { lazy, Suspense, useState, useEffect } from 'react';
// import { useLocation, useNavigate } from 'react-router-dom';
// import Breadcrumbs from './Breadcrumbs';
// import SideBar from './SideBar';
// import CompanyProfile from './Content/CompanyActions/CompanyProfile';
// import AllJob from './Content/CompanyActions/ViewJobs';
// import Dashboard from './Content/Dashboard';
// import ScheduleTestt from './Content/CompanyActions/JobActions/ScheduleTest';

// const AllCompanies = lazy(() => import('./Content/AllCompanies'));
// const AddCompany = lazy(() => import('./Content/AddCompany'));
// const DeleteCompanyPopup = lazy(() => import('./Content/CompanyActions/DeleteCompanyPopup'));
// const CreateJDForm = lazy(() => import('./Content/CompanyActions/MainContent'));
// const UploadJDForm = lazy(() => import('./Content/CompanyActions/UploadJD'));
// const AfterJD = lazy(() => import('./Content/CompanyActions/AfterJD'));
// const EditCompanyProfile = lazy(() => import('./Content/CompanyActions/EditCompanyProfile'));
// const JobDescription = lazy(() => import('./Content/CompanyActions/JobActions/JobDescription'));
// const EnrollCandidatePopup = lazy(() => import('./Content/CompanyActions/JobActions/UploadResume'));
// const ViewAllCandidates = lazy(() => import('./Content/CompanyActions/JobActions/All'));
// const DeleteJobPopup = lazy(() => import('./Content/CompanyActions/JobActions/DeleteJobPopup'));
// const EditJob = lazy(() => import('./Content/CompanyActions/JobActions/MainContent'));

// const getActiveMainFromPath = (pathname) => {
//     if (pathname.startsWith('/company-admin-home')) return 'dashboard';
//     if (pathname.startsWith('/all-companies')) return 'all-companies';
//     if (pathname.startsWith('/add-company-profile')) return 'add-company';
//     if (pathname.startsWith('/company-profile')) return 'company-profile';
//     if (pathname.startsWith('/all-jobs')) return 'view-jobs';
//     if (pathname.startsWith('/create-JD')) return 'create-jd';
//     if (pathname.startsWith('/upload-JD')) return 'upload-jd';
//     if (pathname.startsWith('/after-JD')) return 'after-jd';
//     if (pathname.startsWith('/edit-company-profile')) return 'edit-company-profile';
//     if (pathname.startsWith('/job-description')) return 'job-description';
//     if (pathname.startsWith('/all-candidates')) return 'view-all-candidates';
//     if (pathname.startsWith('/edit-job')) return 'edit-job';
//     if (pathname.startsWith('/view-test')) return 'view-test';
//     return 'dashboard';
// };

// export default function Content() {
//     const location = useLocation();
//     const navigate = useNavigate();
//     const jobID = new URLSearchParams(location.search).get("jobID");
//     const companyID = new URLSearchParams(location.search).get("companyID");
//     const jobDetailsFromState = location.state?.jobDetails || null;
//     const candidatesFromState = location.state?.candidates || [];

//     const [activeMain, setActiveMain] = useState(() => getActiveMainFromPath(location.pathname));
//     const [selectedJob, setSelectedJob] = useState(null);
//     const [selectedCompany, setSelectedCompany] = useState(null);
//     const [showDeleteCompanyPopup, setShowDeleteCompanyPopup] = useState(false);
//     const [showDeleteJobPopup, setShowDeleteJobPopup] = useState(false);
//     const [showEnrollCandidatePopup, setShowEnrollCandidatePopup] = useState(false);
//     const [previousActiveMain, setPreviousActiveMain] = useState('dashboard');

//     useEffect(() => {
//         const newActiveMain = getActiveMainFromPath(location.pathname);
//         if (newActiveMain !== activeMain) {
//             setActiveMain(newActiveMain);
//         }
//     }, [location.pathname]);

//     useEffect(() => {
//         if (!showDeleteCompanyPopup && !showDeleteJobPopup && !showEnrollCandidatePopup && activeMain !== previousActiveMain) {
//             setPreviousActiveMain(activeMain);
//         }
//     }, [activeMain, showDeleteCompanyPopup, showDeleteJobPopup, showEnrollCandidatePopup, previousActiveMain]);

//     const handleDeleteCompanyClick = () => {
//         setPreviousActiveMain(activeMain);
//         setShowDeleteCompanyPopup(true);
//     };

//     const handleCloseDeleteCompanyPopup = () => {
//         setShowDeleteCompanyPopup(false);
//     };

//     const handleConfirmDeleteCompany = () => {
//         setShowDeleteCompanyPopup(false);
//         setSelectedCompany(null);
//         navigate('/all-companies');
//     };

//     const handleDeleteJobClick = () => {
//         setPreviousActiveMain(activeMain);
//         setShowDeleteJobPopup(true);
//     };

//     const handleCloseDeleteJobPopup = () => {
//         setShowDeleteJobPopup(false);
//     };

//     const handleConfirmDeleteJob = (companyID) => {
//         setShowDeleteJobPopup(false);
//         setSelectedJob(null);
//         navigate(`/all-jobs?companyID=${encodeURIComponent(companyID)}`, {
//             state: { companyID: companyID }
//         });
//     };

//     const handleEnrollCandidateClick = () => {
//         setPreviousActiveMain(activeMain);
//         setShowEnrollCandidatePopup(true);
//     };

//     const handleCloseEnrollCandidatePopup = () => {
//         setShowEnrollCandidatePopup(false);
//     };

//     const handleConfirmEnrollCandidate = () => {
//         setShowEnrollCandidatePopup(false);
//     };

//     return (
//         <div className="page-container">
//             <div className="content-container">
//                 <SideBar
//                     activeMain={activeMain}
//                     setActiveMain={setActiveMain}
//                     selectedCompany={selectedCompany}
//                     selectedJob={selectedJob}
//                     setSelectedCompany={setSelectedCompany}
//                     setSelectedJob={setSelectedJob}
//                     onDeleteCompanyClick={handleDeleteCompanyClick}
//                     onDeleteJobClick={handleDeleteJobClick}
//                     onEnrollCandidateClick={handleEnrollCandidateClick}
//                     navigate={navigate}
//                 />
//                 <div style={{ width: "100%" }}>
//                     <Breadcrumbs
//                         activeMain={activeMain}
//                         selectedCompany={selectedCompany}
//                         selectedJob={selectedJob}
//                         setSelectedCompany={setSelectedCompany}
//                         setSelectedJob={setSelectedJob}
//                         navigate={navigate}
//                     />
//                     <div>
//                         <Suspense fallback={<div>Loading...</div>}>
//                             {activeMain === 'dashboard' && <Dashboard />}
//                             {activeMain === 'all-companies' && <AllCompanies setActiveMain={setActiveMain} setSelectedCompany={setSelectedCompany} />}
//                             {activeMain === 'add-company' && <AddCompany />}
//                             {activeMain === 'company-profile' && <CompanyProfile activeMain={activeMain} setActiveMain={setActiveMain} selectedCompany={selectedCompany} setSelectedCompany={setSelectedCompany} />}
//                             {activeMain === 'view-jobs' && <AllJob selectedCompany={selectedCompany} setActiveMain={setActiveMain} setSelectedJob={setSelectedJob} />}
//                             {activeMain === 'create-jd' && <CreateJDForm selectedCompany={selectedCompany} />}
//                             {activeMain === 'upload-jd' && <UploadJDForm selectedCompany={selectedCompany} />}
//                             {activeMain === 'after-jd' && <AfterJD />}
//                             {activeMain === 'edit-company-profile' && <EditCompanyProfile activeMain={activeMain} setActiveMain={setActiveMain} selectedCompany={selectedCompany} setSelectedCompany={setSelectedCompany} />}
//                             {activeMain === 'job-description' && <JobDescription selectedCompany={selectedCompany} selectedJob={selectedJob} />}
//                             {activeMain === 'view-all-candidates' && <ViewAllCandidates selectedJob={selectedJob} handleEnrollCandidateClick={handleEnrollCandidateClick} />}
//                             {activeMain === 'edit-job' && <EditJob activeMain={activeMain} setActiveMain={setActiveMain} selectedCompany={selectedCompany} setSelectedCompany={setSelectedCompany} />}
//                             {activeMain === 'view-test' && (
//                                 <ScheduleTestt
//                                     candidates={candidatesFromState}
//                                     jobDetails={jobDetailsFromState}
//                                     selectedJobId={jobID}
//                                     onClose={() => navigate(-1)}
//                                 />
//                             )}
//                         </Suspense>
//                     </div>
//                 </div>
//             </div>

//             {showDeleteCompanyPopup && (
//                 <Suspense fallback={<div>Loading Delete Popup...</div>}>
//                     <DeleteCompanyPopup
//                         companyName={selectedCompany?.name || 'the selected company'}
//                         onClose={handleCloseDeleteCompanyPopup}
//                         onConfirm={handleConfirmDeleteCompany}
//                     />
//                 </Suspense>
//             )}

//             {showDeleteJobPopup && (
//                 <Suspense fallback={<div>Loading Delete Popup...</div>}>
//                     <DeleteJobPopup
//                         jobName={selectedJob?.job_title || 'the selected job'}
//                         onClose={handleCloseDeleteJobPopup}
//                         onConfirm={handleConfirmDeleteJob}
//                     />
//                 </Suspense>
//             )}

//             {showEnrollCandidatePopup && (
//                 <Suspense fallback={<div>Loading Enroll Popup...</div>}>
//                     <EnrollCandidatePopup
//                         jobId={selectedJob?.job_id || 'the selected job'}
//                         onClose={handleCloseEnrollCandidatePopup}
//                         onConfirm={handleConfirmEnrollCandidate}
//                     />
//                 </Suspense>
//             )}
//         </div>
//     );
// }

import React, { lazy, Suspense, useState, useEffect } from 'react';
import { useLocation, useNavigate, Navigate } from 'react-router-dom';
import Breadcrumbs from './Breadcrumbs';
import SideBar from './SideBar';
import { useAuth } from './Context/AuthContext';
import NotFound from '../Components/NotFound';
import './overall.css';
import CompanyProfile from './Content/CompanyActions/CompanyProfile';
import AllJob from './Content/CompanyActions/ViewJobs';
import Dashboard from './Content/Dashboard';
import ViewTest from './Content/CompanyActions/JobActions/ViewTest';
import { getApiUrl } from './utils/api';

const AllCompanies = lazy(() => import('./Content/AllCompanies'));
const AddCompany = lazy(() => import('./Content/AddCompany'));
const DeleteCompanyPopup = lazy(() => import('./Content/CompanyActions/DeleteCompanyPopup'));
const CreateJDForm = lazy(() => import('./Content/CompanyActions/MainContent'));
// Reuse the working HireWithUs upload flow (companyID-aware, routes to /create-JD
// on success) instead of the legacy admin UploadJD, which posted to a hardcoded
// URL with no company context and dead-ended after upload.
const UploadJDForm = lazy(() => import('../HireWithUs/Pages/PostJob/UploadJD'));
const AfterJD = lazy(() => import('./Content/CompanyActions/AfterJD'));
const EditCompanyProfile = lazy(() => import('./Content/CompanyActions/EditCompanyProfile'));
const JobDescription = lazy(() => import('./Content/CompanyActions/JobActions/JobDescription'));
const EnrollCandidatePopup = lazy(() => import('./Content/CompanyActions/JobActions/UploadResume'));
const ViewAllCandidates = lazy(() => import('./Content/CompanyActions/JobActions/All'));
const DeleteJobPopup = lazy(() => import('./Content/CompanyActions/JobActions/DeleteJobPopup'));
const EditJob = lazy(() => import('./Content/CompanyActions/JobActions/MainContent'));
const SuperAdminDashboard = lazy(() => import('./Content/SuperAdminDashboard'));
const CheatingFeatures = lazy(() => import('./Content/CheatingFeatures'));
const Services = lazy(() => import('./Content/Services'));
const AuditLog = lazy(() => import('./Content/AuditLog'));
const Security = lazy(() => import('./Content/Security'));
const AdminRecruiters = lazy(() => import('./Content/AdminRecruiters'));
const BlogManager = lazy(() => import('./Content/BlogManager'));
const WhatsAppAccess = lazy(() => import('./Content/WhatsAppAccess'));
const FeatureAccess = lazy(() => import('./Content/FeatureAccess'));
const TalentPool = lazy(() => import('./Content/TalentPool'));
const PlanRequests = lazy(() => import('./Content/PlanRequests'));
// WhatsApp Inbox — reuses the HireWithUs inbox panel with scope="global"
// (all companies). Backend enforces that global requires a super-admin.
const WhatsAppConversations = lazy(() => import('../HireWithUs/Pages/Messages/WhatsAppInbox').then(m => ({ default: m.WhatsAppInboxPanel })));
// HireWithUs Post Job + AI generator (reused)
const PostJobForm = lazy(() => import('../HireWithUs/Pages/PostJob/PostJobForm').then(m => ({ default: m.PostJobForm })));
const JdAi = lazy(() => import('../HireWithUs/Pages/PostJob/JdAi'));
// Credit Management
const AdminCreditConfig = lazy(() => import('./Content/CompanyActions/CreditManagement/AdminCreditConfig'));
const CreditPlansPage = lazy(() => import('./Content/CompanyActions/CreditManagement/CreditPlansPage'));
const CompanyCreditsPage = lazy(() => import('./Content/CompanyActions/CreditManagement/CompanyCreditsPage'));
const CreditUsagePage = lazy(() => import('./Content/CompanyActions/CreditManagement/CreditUsagePage'));
const CouponsPage = lazy(() => import('./Content/CompanyActions/CreditManagement/CouponsPage'));
const BillingPage = lazy(() => import('./Content/CompanyActions/CreditManagement/BillingPage'));

const getActiveMainFromPath = (pathname) => {
    if (pathname.startsWith('/super-admin-management')) return 'super-admin-management';
    if (pathname.startsWith('/cheating-features')) return 'cheating-features';
    if (pathname.startsWith('/services')) return 'services';
    if (pathname.startsWith('/audit-logs')) return 'audit-logs';
    if (pathname.startsWith('/whatsapp-conversations')) return 'whatsapp-conversations';
    if (pathname.startsWith('/security')) return 'security';
    if (pathname.startsWith('/admin-recruiters')) return 'admin-recruiters';
    if (pathname.startsWith('/blog-manager')) return 'blog-manager';
    if (pathname.startsWith('/whatsapp-access')) return 'whatsapp-access';
    if (pathname.startsWith('/feature-access')) return 'feature-access';
    if (pathname.startsWith('/talent-pool')) return 'talent-pool';
    if (pathname.startsWith('/plan-requests')) return 'plan-requests';
    if (pathname.startsWith('/company-admin-home')) return 'dashboard';
    if (pathname.startsWith('/all-companies')) return 'all-companies';
    if (pathname.startsWith('/add-company-profile')) return 'add-company';
    if (pathname.startsWith('/company-profile')) return 'company-profile';
    if (pathname.startsWith('/all-jobs')) return 'view-jobs';
    if (pathname.startsWith('/create-JD')) return 'create-jd';
    if (pathname.startsWith('/upload-JD')) return 'upload-jd';
    if (pathname.startsWith('/generate-jd')) return 'generate-jd';
    if (pathname.startsWith('/after-JD')) return 'after-jd';
    if (pathname.startsWith('/edit-company-profile')) return 'edit-company-profile';
    if (pathname.startsWith('/job-description')) return 'job-description';
    if (pathname.startsWith('/all-candidates')) return 'view-all-candidates';
    if (pathname.startsWith('/edit-job')) return 'edit-job';
    if (pathname.startsWith('/view-test')) return 'view-test';
    if (pathname.startsWith('/admin/credits/config')) return 'credit-config';
    if (pathname.startsWith('/admin/credits/plans')) return 'credit-plans';
    if (pathname.startsWith('/admin/credits/companies')) return 'credit-companies';
    if (pathname.startsWith('/admin/credits/usage')) return 'credit-usage';
    if (pathname.startsWith('/admin/credits/coupons')) return 'credit-coupons';
    if (pathname.startsWith('/admin/credits/billing')) return 'billing';
    // Unknown path — do NOT default into the admin dashboard. Returning null
    // lets <Content> render a 404 instead of leaking the admin shell for any
    // random URL (e.g. /dfg).
    return null;
};

export default function Content() {
    const location = useLocation();
    const navigate = useNavigate();
    const { isAdminAuthenticated, isLoading: isAuthLoading } = useAuth();
    const jobID = new URLSearchParams(location.search).get("jobID");
    const companyID = new URLSearchParams(location.search).get("companyID");
    const jobDetailsFromState = location.state?.jobDetails || null;
    const candidatesFromState = location.state?.candidates || [];

    const [activeMain, setActiveMain] = useState(() => getActiveMainFromPath(location.pathname));
    const [selectedJob, setSelectedJob] = useState(null);
    const [selectedCompany, setSelectedCompany] = useState(null);
    const [showDeleteCompanyPopup, setShowDeleteCompanyPopup] = useState(false);
    const [showDeleteJobPopup, setShowDeleteJobPopup] = useState(false);
    const [showEnrollCandidatePopup, setShowEnrollCandidatePopup] = useState(false);
    const [previousActiveMain, setPreviousActiveMain] = useState('dashboard');

    useEffect(() => {
        const newActiveMain = getActiveMainFromPath(location.pathname);
        if (newActiveMain !== activeMain) {
            setActiveMain(newActiveMain);
        }
    }, [location.pathname]);

    useEffect(() => {
        if (!showDeleteCompanyPopup && !showDeleteJobPopup && !showEnrollCandidatePopup && activeMain !== previousActiveMain) {
            setPreviousActiveMain(activeMain);
        }
    }, [activeMain, showDeleteCompanyPopup, showDeleteJobPopup, showEnrollCandidatePopup, previousActiveMain]);

    // Restore selected company and job from URL parameters on page load
    useEffect(() => {
        const restoreFromURL = async () => {
            if (companyID && !selectedCompany) {
                try {
                    const response = await fetch(getApiUrl(`/api/get_company_by_ID?companyID=${encodeURIComponent(companyID)}`), {
                        credentials: 'include'
                    });
                    if (response.ok) {
                        const companyData = await response.json();
                        setSelectedCompany(companyData);
                    }
                } catch (error) {
                    console.error("Error restoring company from URL:", error);
                }
            }

            if (jobID && !selectedJob) {
                try {
                    const response = await fetch(getApiUrl(`/api/job_description?jobId=${jobID}`), {
                        credentials: 'include'
                    });
                    if (response.ok) {
                        const jobData = await response.json();
                        setSelectedJob(jobData);
                    }
                } catch (error) {
                    console.error("Error restoring job from URL:", error);
                }
            }
        };

        restoreFromURL();
    }, [companyID, jobID, selectedCompany, selectedJob]);

    const handleDeleteCompanyClick = () => {
        setPreviousActiveMain(activeMain);
        setShowDeleteCompanyPopup(true);
    };

    const handleCloseDeleteCompanyPopup = () => {
        setShowDeleteCompanyPopup(false);
    };

    const handleConfirmDeleteCompany = async () => {
        // Debug log removed — was leaking companyID to console.
        if (!companyID) {
            console.error("No company selected for deletion.");
            return;
        }
    
        try {
            const response = await fetch(getApiUrl(`/api/delete_company?companyID=${encodeURIComponent(companyID)}`), {
                method: 'DELETE',
                credentials: 'include'
            });
    
            if (response.ok) {
                // Debug log removed — was state-machine noise.
                setShowDeleteCompanyPopup(false);
                setSelectedCompany(null);
                navigate('/all-companies'); // Navigate after successful deletion
            } else {
                const data = await response.json();
                alert(`Failed to delete company: ${data.error}`);
            }
        } catch (error) {
            console.error("Error deleting company:", error);
            alert("An error occurred while deleting the company.");
        }
        // console.log("Company deleted!");
        // setShowDeleteCompanyPopup(false);
        // setSelectedCompany(null);
        // navigate('/all-companies'); // Navigate to all companies after deletion
    };

    const handleDeleteJobClick = () => {
        setPreviousActiveMain(activeMain);
        setShowDeleteJobPopup(true);
    };

    const handleCloseDeleteJobPopup = () => {
        setShowDeleteJobPopup(false);
    };

    const handleConfirmDeleteJob = (companyID) => {
        setShowDeleteJobPopup(false);
        setSelectedJob(null);
        navigate(`/all-jobs?companyID=${encodeURIComponent(companyID)}`, {
            state: { companyID: companyID }
        });
    };

    const handleEnrollCandidateClick = () => {
        setPreviousActiveMain(activeMain);
        setShowEnrollCandidatePopup(true);
    };

    const handleCloseEnrollCandidatePopup = () => {
        setShowEnrollCandidatePopup(false);
    };

    const handleConfirmEnrollCandidate = () => {
        setShowEnrollCandidatePopup(false);
    };

    // --- Route + auth guards (must run after all hooks above) ---------------
    // 1) Unknown/garbage URL (e.g. /dfg): show a real 404 instead of the admin
    //    panel. This applies whether or not the visitor is logged in.
    if (getActiveMainFromPath(location.pathname) === null) {
        return <NotFound />;
    }

    // 2) Valid admin path but not authenticated as an admin: never render the
    //    admin shell — send the visitor to the admin login page.
    if (isAuthLoading) {
        return (
            <div className="flex items-center justify-center h-screen text-slate-400">
                Loading…
            </div>
        );
    }
    if (!isAdminAuthenticated) {
        return <Navigate to="/hirewithus/login" replace />;
    }

    return (
        <div className="flex h-screen font-[Poppins,sans-serif]">
            <SideBar
                activeMain={activeMain}
                setActiveMain={setActiveMain}
                selectedCompany={selectedCompany}
                selectedJob={selectedJob}
                setSelectedCompany={setSelectedCompany}
                setSelectedJob={setSelectedJob}
                onDeleteCompanyClick={handleDeleteCompanyClick}
                onDeleteJobClick={handleDeleteJobClick}
                onEnrollCandidateClick={handleEnrollCandidateClick}
                navigate={navigate}
            />
            <div className="flex-1 flex flex-col min-h-0 overflow-y-auto [scrollbar-width:none] [-ms-overflow-style:none] ca-scrollable">
                <Breadcrumbs
                    activeMain={activeMain}
                    selectedCompany={selectedCompany}
                    selectedJob={selectedJob}
                    setSelectedCompany={setSelectedCompany}
                    setSelectedJob={setSelectedJob}
                    navigate={navigate}
                />
                <div className="flex-1">
                    <Suspense fallback={<div className="flex items-center justify-center h-32 text-slate-400">Loading…</div>}>
                            {!!(activeMain === 'super-admin-management') && <SuperAdminDashboard />}
                            {!!(activeMain === 'cheating-features') && <CheatingFeatures />}
                            {!!(activeMain === 'services') && <Services />}
                            {!!(activeMain === 'audit-logs') && <AuditLog />}
                            {!!(activeMain === 'whatsapp-conversations') && <WhatsAppConversations scope="global" />}
                            {!!(activeMain === 'security') && <Security />}
                            {!!(activeMain === 'admin-recruiters') && <AdminRecruiters />}
                            {!!(activeMain === 'blog-manager') && <BlogManager />}
                            {!!(activeMain === 'whatsapp-access') && <WhatsAppAccess />}
                            {!!(activeMain === 'feature-access') && <FeatureAccess />}
                            {!!(activeMain === 'talent-pool') && <TalentPool />}
                            {!!(activeMain === 'plan-requests') && <PlanRequests />}
                            {!!(activeMain === 'dashboard') && <Dashboard />}
                            {!!(activeMain === 'all-companies') && <AllCompanies setActiveMain={setActiveMain} setSelectedCompany={setSelectedCompany} />}
                            {!!(activeMain === 'add-company') && <AddCompany />}
                            {!!(activeMain === 'company-profile') && <CompanyProfile activeMain={activeMain} setActiveMain={setActiveMain} selectedCompany={selectedCompany} setSelectedCompany={setSelectedCompany} />}
                            {!!(activeMain === 'view-jobs') && <AllJob selectedCompany={selectedCompany} setActiveMain={setActiveMain} setSelectedJob={setSelectedJob} />}
                            {!!(activeMain === 'create-jd') && <PostJobForm />}
                            {!!(activeMain === 'upload-jd') && <UploadJDForm embedded />}
                            {!!(activeMain === 'generate-jd') && <JdAi embedded />}
                            {!!(activeMain === 'after-jd') && <AfterJD />}
                            {!!(activeMain === 'edit-company-profile') && <EditCompanyProfile activeMain={activeMain} setActiveMain={setActiveMain} selectedCompany={selectedCompany} setSelectedCompany={setSelectedCompany} />}
                            {!!(activeMain === 'job-description') && <JobDescription selectedCompany={selectedCompany} selectedJob={selectedJob} />}
                            {!!(activeMain === 'view-all-candidates') && <ViewAllCandidates selectedJob={selectedJob} handleEnrollCandidateClick={handleEnrollCandidateClick} />}
                            {!!(activeMain === 'edit-job') && <EditJob activeMain={activeMain} setActiveMain={setActiveMain} selectedCompany={selectedCompany} setSelectedCompany={setSelectedCompany} />}
                            {!!(activeMain === 'view-test') && <ViewTest activeMain={activeMain} setActiveMain={setActiveMain} selectedCompany={selectedCompany} selectedJob={selectedJob} setSelectedCompany={setSelectedCompany} />}
                            {!!(activeMain === 'credit-config') && <AdminCreditConfig />}
                            {!!(activeMain === 'credit-plans') && <CreditPlansPage />}
                            {!!(activeMain === 'credit-companies') && <CompanyCreditsPage />}
                            {!!(activeMain === 'credit-usage') && <CreditUsagePage />}
                            {!!(activeMain === 'credit-coupons') && <CouponsPage />}
                            {!!(activeMain === 'billing') && <BillingPage />}
                        </Suspense>
                </div>
            </div>

            {showDeleteCompanyPopup && (
                <Suspense fallback={<div>Loading Delete Popup...</div>}>
                    <DeleteCompanyPopup
                        companyName={selectedCompany?.name || 'the selected company'}
                        onClose={handleCloseDeleteCompanyPopup}
                        onConfirm={handleConfirmDeleteCompany}
                    />
                </Suspense>
            )}

            {showDeleteJobPopup && (
                <Suspense fallback={<div>Loading Delete Popup...</div>}>
                    <DeleteJobPopup
                        jobName={selectedJob?.job_title || 'the selected job'}
                        onClose={handleCloseDeleteJobPopup}
                        onConfirm={handleConfirmDeleteJob}
                    />
                </Suspense>
            )}

            {showEnrollCandidatePopup && (
                <Suspense fallback={<div>Loading Enroll Popup...</div>}>
                    <EnrollCandidatePopup
                        jobId={selectedJob?.job_id || 'the selected job'}
                        onClose={handleCloseEnrollCandidatePopup}
                        onConfirm={handleConfirmEnrollCandidate}
                    />
                </Suspense>
            )}
        </div>
    );
}